import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { LanguageProvider } from '../../core/language-provider';

// Static PDFs served from /public/docs. Update these files to update the policy.
export const CANDIDATE_PRIVACY_PDF = {
    ita: '/docs/privacy-policy-candidati-it.pdf',
    eng: '/docs/privacy-policy-candidati-en.pdf'
};

export function getCandidatePrivacyPdf() {
    let lang = 'ita';
    try {
        lang = localStorage.getItem('lang') === 'eng' ? 'eng' : 'ita';
    } catch {
        lang = 'ita';
    }
    return CANDIDATE_PRIVACY_PDF[lang] || CANDIDATE_PRIVACY_PDF.ita;
}

const CandidatePrivacyContext = createContext({ open: () => {}, close: () => {} });

export function useCandidatePrivacy() {
    return useContext(CandidatePrivacyContext);
}

export function CandidatePrivacyProvider({ children }) {
    const [show, setShow] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);

    const open = useCallback((e) => {
        if (e && typeof e.preventDefault === 'function') e.preventDefault();
        setPdfUrl(getCandidatePrivacyPdf());
        setShow(true);
    }, []);

    const close = useCallback(() => setShow(false), []);

    const value = useMemo(() => ({ open, close }), [open, close]);

    const title = LanguageProvider.get('footerTexts.legal.candidatesPrivacyPolicy');

    return (
        <CandidatePrivacyContext.Provider value={value}>
            {children}
            <Modal show={show} onHide={close} size='xl' centered scrollable>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: 0, height: '75vh' }}>
                    {pdfUrl && (
                        <iframe
                            title={title}
                            src={pdfUrl}
                            style={{ width: '100%', height: '100%', border: 'none' }}
                        />
                    )}
                </Modal.Body>
                <Modal.Footer>
                    {pdfUrl && (
                        <a href={pdfUrl} target='_blank' rel='noreferrer' className='me-auto'>
                            {LanguageProvider.get('defaults.open_file')}
                        </a>
                    )}
                    <Button variant='secondary' onClick={close}>
                        {LanguageProvider.get('defaults.close')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </CandidatePrivacyContext.Provider>
    );
}
